export function registerServiceWorker() {
  if (
    process.env.NODE_ENV !== "production"
    || !("serviceWorker" in navigator)
    || window.location.protocol !== "https:"
  ) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => registration.update())
      .catch((error) => {
        console.warn("PWA service worker kaydedilemedi:", error);
      });
  });
}
